<template>
  <div :style="{ textDecoration: 'none' }">
    <div :style="{ margin: '1rem 0 .2rem', fontWeight: '600', fontSize: $fontSizes[2], color: $colors.grey.base }">
      Upgrade for more storage
    </div>
    <div :style="{ fontSize: $fontSizes[2], color: storageUsedInPercent > STORAGE_HINT_LIMIT ? $colors.red.base : $colors.grey.darken4 }">
      Your account has used up {{ Math.round(userService.currentUser.value.subscriptionData.storageUsed / 10000) / 100 }} Mb
      of the limit of {{ currentPlan.storageLimit / 1000000 }} Mb ({{ storageUsedInPercent }}
      %).
    </div>
    <c-progress-bar
      :progress="storageUsedInPercent"
      :style="{ margin: '1rem 0'}"
    />
  </div>
</template>
<script setup>
import CProgressBar from 'shared/components/CProgressBar.vue';
import useSubscription from 'shared/services/subscription';
import {
  BETA_PHASE_MANAGER,
  STORAGE_HINT_LIMIT,
  USER_SERVICE,
} from 'shared/constants';
import { computed, inject } from 'vue';

const betaPhaseManager = inject(BETA_PHASE_MANAGER);
const userService = inject(USER_SERVICE);
const { currentPlan } = useSubscription(userService.currentUser, betaPhaseManager);
const storageUsedInPercent = computed(() => Math.round((userService.currentUser.value.subscriptionData.storageUsed / currentPlan.value.storageLimit) * 100));
</script>
